import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Warehouses } from 'app/_models/warehouses';
import { Observable, Subject } from 'rxjs';
import { UserModel } from 'app/_models/user-model';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CrudWarehouseService {
  private _refreshrequired = new Subject<void>();
  private readonly _baseUrl: string;
  constructor(private http: HttpClient) {
    this._baseUrl = environment.baseUrl;
   }
   currentUser: UserModel;

   get Refreshrequired() {
    return this._refreshrequired;
  }

  GetAllWareHouses() {
    return this.http.get<Warehouses[]>(this._baseUrl + 'Common/GetAllWareHouses');
  }

  getActiveWareHouses() {
    return this.http.get<any>(this._baseUrl + 'Common/GetActiveWareHouses');
  }


  getPagedActiveWareHouses(model:any): Observable<any>{
    let headers = new HttpHeaders({
      'x-api-version': '2.0'
        });
    let options = { headers: headers,  withCredentials: true  };
    return this.http.post<any>(`${this._baseUrl}Common/GetActiveWareHouses`, model, options);
  }

  deleteWarehouse(warehouseId:number): Observable<any> {
    let model = {id: warehouseId}
      return this.http.post<any>(this._baseUrl +'Common/DeleteWarehouse', model).pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
    }


   updateWareHouse(model:any):Observable<any> { 
    return this.http.post<any>(this._baseUrl + 'Common/UpdateWarehouse', model).pipe(
      tap(() => {
        this.Refreshrequired.next();
      })
    );
   }

   saveWareHouse(model:any):Observable<any> {
    return this.http.post<any>(this._baseUrl + 'Common/SaveWarehouse', model).pipe(
      tap(() => {
        this.Refreshrequired.next();
      })
    );
   }


}
